import { Injectable } from '@angular/core';
import { ApiService } from '../../services/apiservice/apiservice.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { ConfigService } from '../../services/config/config.service';
import { map, tap } from 'rxjs/operators';
import { AnnouncementInfo } from '../../services/announcement.service';

export interface IPreferenceItem {
  name: string;
  label: string;
  show: boolean;
  preferenceActive: string;
  preferenceList: IPreferenceItemValue[];
}

interface IPreferenceItemValue {
  label: string;
  value: string;
  isChecked: boolean;
}

@Injectable()
export class AccountService {
  private readonly _accountUrl: string;
  constructor(
    private _apiService: ApiService,
    private _configService: ConfigService,
  ) {
    this._accountUrl = `${this._configService.agApi}/account`;
  }

  private _userPreferences = new BehaviorSubject<IPreferenceItem[]>(null);

  userPreferences$ = this._userPreferences.asObservable();

  getProfileDetails(): Observable<any> {
    const data = '';
    const url = `${this._accountUrl}/GetProfile`;
    return this._apiService.post(url, data);
  }

  updateProfileDetails(data): Observable<any> {
    const url = `${this._accountUrl}/UpdateMyProfile`;
    return this._apiService.postWithTokenFormData(url, data);
  }

  getUserPreferences(): Observable<IPreferenceItem[]> {
    const url = `${this._accountUrl}/GetPreferences`;

    return this._apiService.get<IPreferenceItem[]>(url).pipe(
      tap((preferences: IPreferenceItem[]) => {
        this._userPreferences.next(preferences);
      }),
    );
  }

  updateUserPreferences(data): Observable<any> {
    const url = `${this._accountUrl}/UpdatePreferences`;
    return this._apiService.post(url, data).pipe(
      map(() => {
        this.getUserPreferences().subscribe();
      }),
    );
  }

  checkPatronAlertMessage(): Observable<any> {
    const url = `${this._accountUrl}/GetBlockedPatronAlertMsg`;
    return this._apiService.get(url);
  }

  getAnnouncements(): Observable<AnnouncementInfo[]> {
    const url = `${this._accountUrl}/announcements`;
    return this._apiService.get(url);
  }

  dismissAnnouncements(announcementIds: number[]): Observable<void> {
    const url = `${this._accountUrl}/announcements/dismiss`;
    return this._apiService.post(url, { announcementIds });
  }
}
